import { render } from "./DrugQuickCreateModal.vue?vue&type=template&id=051c89ee&scoped=true"
import script from "./DrugQuickCreateModal.vue?vue&type=script&lang=js"
export * from "./DrugQuickCreateModal.vue?vue&type=script&lang=js"

import "./DrugQuickCreateModal.vue?vue&type=style&index=0&id=051c89ee&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051c89ee"]])

export default __exports__